import { Alert } from 'antd'

export const AlertHandler = ({ errorState }) => {
  return (
    <div className="mt-4">
      {errorState ? <Alert showIcon message={errorState.type} description={errorState.message} type="error" /> : <></>}
    </div>
  )
}
